<template>
  <main>
    <div
      class="koc-view koc-events-purchase-view"
      data-observe-resize
      data-observe-theme
    >
      <div
        v-if="state.event"
      >
        <div class="koc-wrapper-component kol-wrapper">
          <div class="koc-events-price-box-container koc-medium">
            <event-price-box-component
              :event="state.event"
              :show-checkout="state.showCheckout"
              :user="state.hasUser"
              :user-events="state.userEvents"
              :in-person-only="state.inPersonOnly"
              @show-login="showLogin"
              @show-checkout="showCheckout"
            />
          </div>
          <div
            v-if="state.showCheckout"
            class="koc-events-checkout-container"
          >
            <div
              class="koc-purchase-event-view"
            >
              <div class="koc-wrapper-component">
                <main>
                  <div class="koc-panel-component">
                    <header>
                      <section class="koc-header-primary">
                        <span>CHECKOUT&nbsp;| </span> <span class="koc-header-primary-event-name"> {{ state.event.name }}</span>
                      </section>
                    </header>

                    <section
                      v-if="!state.user"
                      class="koc-section"
                    >
                      <div class="koc-full">
                        <p
                          v-if="state.loginErrorMessage"
                          class="koc-events-checkout-login-error-message"
                        >
                          {{ state.loginErrorMessage }}
                        </p>
                        <p
                          v-else
                          class="koc-events-checkout-login-message"
                        >
                          Have a KelbyOne Member account? Please use those login details
                          to log in.
                        </p>
                      </div>
                      <auth-login-register-component
                        @login="interiorLogin"
                        @register="register"
                      />
                    </section>

                    <section
                      v-if="state.hasInPerson && !state.inPersonOnly"
                      class="koc-section"
                    >
                      <event-product-select-component
                        :options="state.formattedProducts"
                        :selected="state.selected"
                        title="Choose Your Experience"
                        @product-change="switchProduct"
                      />
                    </section>


                    <section class="koc-section">
                      <purchase-summary-component
                        v-if="state.preview"
                        :options="state.productOptions"
                        :preview="state.preview"
                      />
                      <purchase-coupon-component
                        v-if="showCoupon"
                        :coupon="state.coupon"
                        @validate="updateCoupon"
                      />
                    </section>

                    <section
                      v-if="state.user"
                      class="koc-section"
                    >
                      <payment-billing-details-component
                        :default-profile="state.defaultProfile"
                        :profiles="state.profiles"
                        :selected-profile="state.selectedProfile"
                        @activate="activatePayment"
                        @create="createPayment"
                        @remove="removePayment"
                        @update="updatePayment"
                      />
                    </section>

                    <section class="koc-section">
                      <main>
                        <div class="koc-disclaimer koc-full float-right">
                          <purchase-disclaimer-event-component
                            v-if="state.preview"
                            :options="state.productOptions"
                            :preview="state.preview"
                          />
                        </div>
                      </main>
                      <footer>
                        <section class="koc-footer">
                          <div class="koc-full">
                            <p
                              v-if="missingFields()"
                              class="koc-warning koc-row float-right"
                            >
                              {{ missingFields() }}
                            </p>
                          </div>
                          <div class="koc-full">
                            <label
                              class="koc-option koc-terms float-right"
                              for="terms"
                            >
                              <div class="koc-check">
                                <input
                                  id="terms"
                                  v-model="state.terms"
                                  name="terms"
                                  type="checkbox"
                                >
                                <div class="koc-box" />
                              </div>
                              I have read and accept the
                              <a
                                href="https://kelbyonelive.com/terms/"
                                target="_blank"
                              >
                                terms &amp; conditions
                              </a>
                            </label>
                          </div>

                          <div
                            v-if="state.hasOptin"
                            class="koc-full"
                          >
                            <label
                              class="koc-option koc-terms float-right"
                              for="optin"
                            >
                              <div class="koc-check">
                                <input
                                  id="optin"
                                  v-model="state.optin"
                                  name="optin"
                                  type="checkbox"
                                >
                                <div class="koc-box" />
                              </div>
                              <span v-html="state.event.optin.message" />
                            </label>
                          </div>


                          <div class="koc-accept-submit koc-full">
                            <div class="koc-full">
                              <div class="koc-submit float-right">
                                <button
                                  :disabled="!state.canSubmit"
                                  class="koc-button koc-ripple float-right"
                                  @click="purchase"
                                >
                                  CONFIRM PAYMENT
                                </button>
                              </div>
                            </div>
                          </div>
                        </section>
                      </footer>
                    </section>
                    <div
                      v-if="state.showNotification"
                      class="koc-notification koc-full"
                    >
                      <h3>{{ state.notification }}</h3>
                      <div
                        class="koc-close"
                        @click="clearNotification"
                      />
                    </div>
                  </div>
                </main>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        v-else
        class="koc-wrapper-component kol-wrapper"
      >
        <SkeletonLoader
          :image="true"
          :content="true"
          :content-body="1"
          :content-body-flex="true"
        />
      </div>
    </div>
    <div
      v-if="state.showLogin"
      class="koc-notification koc-fixed koc-dark koc-full koc-view koc-dark-theme"
    >
      <div class="koc-login-overlay-form-container">
        <div class="koc-kol-logo-container">
          <img src="@/assets/images/kol-logo-white.png">
        </div>
        <h3 class="koc-auth-login-notification-text">
          {{ state.notification }}
        </h3>
        <auth-login-component @login="login" />
        <div
          class="koc-close"
          @click="closeLogin"
        />
      </div>
    </div>
  </main>
</template>

<script src="./event-price-box-view.js"></script>
<style lang="scss" scoped src="./event-price-box-view.scss"></style>
